// Mirrors computeVirtualRowsFromSelectionMode: only the modes that act on the
// user's selection may honour it. 'dontcare_useall' means every row in the
// filter, so exclusions must not narrow it.
export const computeDeselectedIdsFromSelectionMode = (
  deselectedRowIds: Set<string>,
  selectionMode: string | undefined
): Set<string> => {
  switch (selectionMode) {
    case 'any':
      return deselectedRowIds;
    case 'oneormore':
      return deselectedRowIds;
    default:
      return new Set<string>();
  }
};
